import { ISwAppGeneralSearchApi } from "../../interfaces-and-types";

type TGeneralSearchUrls = { [key in keyof ISwAppGeneralSearchApi]: string };

const rootGeneralSearchUrl = "/search";

export const generalSearchUrls: TGeneralSearchUrls = {
  generalSearchByText: `${rootGeneralSearchUrl}`,
};
